import useRedux from 'hooks/useRedux'
import React from 'react'
import { AiOutlineExclamationCircle } from 'react-icons/ai'
import { useSelector } from 'react-redux'
import { Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap'
import { ApplicationState } from 'store'
import { ATENDIMENTO } from 'store/modules/atendimento/types'
import { CustomButton, SimpleTitleCard } from 'styles/global'
import * as atendimentoActions from 'store/modules/atendimento/actions'

const ModalAtendimentoAtivo = () => {
  const { modalAtendimentoAtivo, atendimentoAtivo } = useSelector<
    ApplicationState,
    ATENDIMENTO
  >((state: ApplicationState) => state.atendimento)
  const { dispatch } = useRedux()
  return (
    <Modal backdrop="static" isOpen={modalAtendimentoAtivo}>
      <ModalHeader>
        <SimpleTitleCard colorIcon="F7931E">
          <AiOutlineExclamationCircle className="icon" />
          Atendimento Ativo
        </SimpleTitleCard>
      </ModalHeader>
      <ModalBody>
        <p className="text-center">
          Você possui um atendimento em andamento com o cliente&nbsp;
          {atendimentoAtivo?.nome}. Finalize-o para continuar.
        </p>
      </ModalBody>
      <ModalFooter className="d-flex justify-content-center">
        <Row className="d-flex">
          <CustomButton
            width={200}
            onClick={() => {
              dispatch(atendimentoActions.continuarAtendimentoDiscadorSaga())
              dispatch(atendimentoActions.setModalAtendimentoAtivo(false))
            }}
          >
            Continuar atendimento
          </CustomButton>
        </Row>
      </ModalFooter>
    </Modal>
  )
}

export default ModalAtendimentoAtivo
